// Kleur van de meter: hoe dichter bij het target, hoe heter (amber naar rood).

const heatStops = [
  [0.0, [255, 214, 150]],
  [0.35, [255, 178, 74]],
  [0.7, [255, 118, 26]],
  [1.0, [255, 58, 18]],
];

export function heatColor(percent, alpha = 1) {
  const p = Math.min(100, Math.max(0, percent)) / 100;

  // Zoek tussen welke twee kleuren dit percentage valt en meng ze.
  let i = 0;
  while (i < heatStops.length - 2 && p > heatStops[i + 1][0]) i += 1;

  const [from, fromColor] = heatStops[i];
  const [to, toColor] = heatStops[i + 1];
  const ratio = to === from ? 0 : (p - from) / (to - from);
  const rgb = fromColor.map((v, k) => Math.round(v + (toColor[k] - v) * ratio));

  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`;
}
